import { BaseDto } from '@/shared/dtos/base-dto';

export class anotaciones_dieta extends BaseDto {
    public anotaciones_html !: string;
    public id_dieta !: number;
 } 
